






import Vue from 'vue'
import { mapState } from 'vuex'
// @ts-ignore
import { GridLoader as Loader } from '@saeris/vue-spinners'

export default Vue.extend({
  name: 'Loading',
  components: {
    Loader
  },
  props: {
    color: {
      type: String,
      default: '#70B0E0',
      validator (value: string) {
        return /^#([A-F0-9]{3}|[A-F0-9]{6})$/i.test(value)
      }
    }
  },
  computed: {
    ...mapState(['loading'])
  }
})
